var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconReport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 101,
    viewBox: "0 0 90 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_519_228",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 91,
    height: 101
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.0068 0.00402832H0.000732422V100.411H90.0068V0.00402832Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_519_228)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.000244141 18.2591V7.36118C-0.000244141 3.29632 3.29187 0.00323486 7.35179 0.00323486H83.5698C87.124 0.00323486 90.0054 2.88467 90.0054 6.44529V92.9703C90.0054 94.9461 89.2215 96.8396 87.8249 98.2392C86.4284 99.6284 84.5356 100.411 82.5611 100.411H7.37179C5.41741 100.411 3.542 99.6387 2.15882 98.2598C0.775639 96.8705 -0.000244141 94.9977 -0.000244141 93.0424V81.208H11.3582C12.5969 81.208 13.6028 80.1994 13.6028 78.9645V74.4778C13.6028 73.2326 12.5969 72.224 11.3582 72.224H-0.000244141V63.2196H11.3582C12.5969 63.2196 13.6028 62.2111 13.6028 60.9659V56.4792C13.6028 55.2443 12.5969 54.2357 11.3582 54.2357H-0.000244141V45.221H11.3582C12.5969 45.221 13.6028 44.2228 13.6028 42.9776V38.4909C13.6028 37.256 12.5969 36.2474 11.3582 36.2474H-0.000244141V27.2327H11.3582C12.5969 27.2327 13.6028 26.2242 13.6028 24.9893V20.5024C13.6028 19.2572 12.5969 18.2591 11.3582 18.2591H-0.000244141ZM43.7639 61.3261C43.7639 59.8545 42.568 58.6505 41.0925 58.6505H35.7511C34.2769 58.6505 33.0797 59.8545 33.0797 61.3261V86.9811C33.0797 88.4527 34.2769 89.6464 35.7511 89.6464H41.0925C42.568 89.6464 43.7639 88.4527 43.7639 86.9811V61.3261ZM77.2545 49.7901C77.2545 48.3185 76.0572 47.1247 74.5831 47.1247H69.2403C67.7662 47.1247 66.569 48.3185 66.569 49.7901V86.9811C66.569 88.4527 67.7662 89.6464 69.2403 89.6464H74.5831C76.0572 89.6464 77.2545 88.4527 77.2545 86.9811V49.7901ZM60.77 39.4581C60.77 37.9763 59.5728 36.7825 58.0986 36.7825H52.7572C51.2818 36.7825 50.0859 37.9763 50.0859 39.4581V86.9811C50.0859 88.4527 51.2818 89.6464 52.7572 89.6464H58.0986C59.5728 89.6464 60.77 88.4527 60.77 86.9811V39.4581Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReport);
export default __webpack_public_path__ + "static/media/icon_report.024fbe7b968a2f70a401f3828ac98340.svg";
export { ForwardRef as ReactComponent };